import React from "react";
import { connect } from "react-redux";

import searchIconGrey from "../../images/search-icon-grey.svg";
import searchLoader from "../../images/loading-spinner.svg";
import Input from "../FormComponents/Input";
import WholePageSearchResults from "./WholePageSearchResults";
import { searchWholePage, searchResult } from "../../actions";

class DesktopSearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchString: "",
      show: true
    };
  }

  componentDidMount() {
    window.addEventListener("mousedown", this.detectClickOutSide);
  }
  componentWillUnmount() {
    window.removeEventListener("mousedown", this.detectClickOutSide);
  }
  detectClickOutSide = e => {
    if (!this.searchResultRef.contains(e.target)) {
      this.setState({ show: false });
    }
  };

  handleSearch = e => {
    this.setState({ searchString: e.target.value });
    if (e.target.value.length > 2) this.props.search(e.target.value, this.props.category);
    else this.props.loadSearchResult([]);
  };

  render() {
    const { searchLoading, searchResult } = this.props;
    return (
      <div className="desktop__search__input" ref={node => (this.searchResultRef = node)}>
        <Input
          placeholder={`Search ${this.props.category}...`}
          leftIcon={searchLoading ? searchLoader : searchIconGrey}
          value={this.state.searchString}
          onChange={this.handleSearch}
          onFocus={() => this.setState({ show: true })}
        />
        {this.state.show &&
          this.state.searchString.length > 2 &&
          searchResult.length > 0 && <WholePageSearchResults results={searchResult} />}
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    searchLoading: state.searchLoading,
    searchResult: state.wholePageSearchResult
  };
};

const mapDispatchToProps = dispatch => {
  return {
    search: (term, category) => dispatch(searchWholePage(term, category)),
    loadSearchResult: list => dispatch(searchResult(list))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DesktopSearchInput);
